import { useState } from 'react'

import Text from '../../Text'
import { BirdviewKpiUnit } from '../DashboardBirdview.constants.charts'

import {
  checkIsBirdviewBarsChartFirstRow,
  checkIsBirdviewBarsChartRowActive,
  getBirdviewBarsChartMaxValue,
} from './BirdviewBarsChart.utils'
import { BirdviewBarsChartRow } from './BirdviewBarsChartRow'

import * as styles from './BirdviewBarsChart.module.css'

// Bars are drawn against the longest one, not against the total.
function BirdviewBarsChart({
  color,
  isStacked,
  items,
  note = null,
  total,
  valueUnit = BirdviewKpiUnit.Count,
  withShare = true,
  onOpen,
}) {
  const [activeId, setActiveId] = useState(null)

  const maxValue = getBirdviewBarsChartMaxValue(items)

  function handleRowsLeave() {
    setActiveId(null)
  }

  return (
    <div className={styles.bars}>
      <ul
        className={styles.list}
        style={{ '--birdview-bar-color': color }}
        onMouseLeave={handleRowsLeave}
      >
        {items.map((item, index) => (
          <BirdviewBarsChartRow
            isActive={checkIsBirdviewBarsChartRowActive({ activeId, item })}
            isStacked={isStacked}
            isTooltipBelow={checkIsBirdviewBarsChartFirstRow(index)}
            item={item}
            key={item.id}
            maxValue={maxValue}
            total={total}
            valueUnit={valueUnit}
            withShare={withShare}
            onEnter={setActiveId}
            onOpen={onOpen}
          />
        ))}
      </ul>
      {note ? (
        <Text isSecondary className={styles.note}>
          {note}
        </Text>
      ) : null}
    </div>
  )
}

export default BirdviewBarsChart
